<div class="page">
    <div class="page-title" *ngIf="page.mostrar_titulo">
        <div class="container">
            <h1 class="wow slideInDown" data-wow-delay="0.7s">{{page.titulo}}</h1>
        </div>
    </div>
    <div class="page-content">
        <div class="section section-description wow fadeIn" data-wow-delay="0.5s">
            <div class="container">
                <article [innerHtml]="page.texto | safeHtml"></article>
            </div>
        </div>
        <div class="section section-description texto-1" data-wow-delay="0.2s">
            <div class="container"> 
                <h2 class="wow slideInUp" data-wow-delay="0.6s">Você já faz parte ?</h2>
                <article class="wow fadeIn" data-wow-delay="0.5s" [innerHtml]="params.texto | safeHtml"></article>
            </div>
        </div>
        <div class="section section-description texto-2" data-wow-delay="0.2s">  
            <div class="container"> 
                <h2 class="wow slideInUp" data-wow-delay="0.6s">Você quer fazer parte ?</h2>
                <article class="wow fadeIn" data-wow-delay="0.5s" [innerHtml]="params.texto2 | safeHtml"></article>
            </div>
        </div>
        <div class="section section-options">
            <div class="section-title">
                <div class="container">
                    <h2 class="wow fadeIn" data-wow-delay="0.5s">Formas de contribuição</h2>
                </div>    
            </div>   
            <div class="section-content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4" *ngFor="let o of options">
                            <div class="item-option wow slideInUp" data-wow-delay="0.5s"> 
                                <div class="icon">
                                    <i class="material-icons">{{o.icon}}</i>
                                </div>   
                                <div class="content">
                                    <h3>{{o.name}}</h3>
                                    <h4>{{o.info}}</h4>
                                    <div class="bank" *ngIf="o.type == 1">
                                        <div class="item">
                                            <strong>Banco: </strong><span>{{o.banco}}</span>
                                        </div>  
                                        <div class="item">
                                            <strong>Agência: </strong><span>{{o.agencia}}</span>
                                        </div>  
                                        <div class="item">
                                            <strong>Conta: </strong><span>{{o.conta}}</span>
                                        </div> 
                                        <div class="item">
                                            <strong>CNPJ: </strong><span>{{o.cnpj}}</span>
                                        </div>
                                    </div>
                                    <div class="cnpj" *ngIf="o.type == 2">
                                        {{o.cnpj}}
                                    </div>   
                                    <div class="content-link" *ngIf="o.link != null">
                                        <a [href]="o.link" target="_blank">
                                            Clique aqui :)
                                        </a>    
                                    </div>    
                                </div>    
                            </div>    
                        </div>   
                    </div>    
                </div>    
            </div>    
        </div> 
        <div class="section section-help">
            <div class="section-title">
                <div class="container">
                    <h2>Ficou com dúvidas?</h2>
                </div>    
            </div>   
            <div class="section-content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="content-text">
                                <p class="text"> 
                                    Ficou com dúvidas de como contribuir?
                                </p>
                                <p class="text">
                                    Nossa equipe está aqui para te ajudar.
                                </p>  
                            </div>  
                        </div>  
                        <div class="col-md-6">
                            <modulo posicao="whatsapp" template="help"></modulo>
                        </div>    
                    </div>    
                </div>
            </div>
        </div>
    </div>    
</div>    
<loader *ngIf="loader"></loader>